import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import * as UsuarioCrud from 'services/usuario.service'

const UsuarioSolicitanteFormGroup = ({ vIdOficinaSolicitante, vIdUsuarioSolicitante, iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [usuarios, setUsuarios] = React.useState([])
  const [usuarioExterno, setUsuarioExterno] = React.useState(null)

  React.useEffect(() => {
    if (vIdOficinaSolicitante) {
      UsuarioCrud.obtenerTodoAsSelect(vIdOficinaSolicitante)
        .then(({ data }) => setUsuarios(data || []))
        .catch((err) => {
          // Fallback silencioso: si el endpoint falla, no rompemos el form,
          // simplemente dejamos la lista vacía. Solo notificamos al usuario si hay un mensaje.
          setUsuarios([])
          const msg = err?.data?.error
          if (msg) __zariContext.snack('error', msg)
        })
    } else {
      setUsuarios([])
    }
  }, [__zariContext, vIdOficinaSolicitante])

  // Si el usuario solicitante viene del requerimiento y no está en la lista de la oficina,
  // hacemos un fetch puntual para mostrar su nombre real en lugar de un placeholder.
  React.useEffect(() => {
    if (!vIdUsuarioSolicitante) {
      setUsuarioExterno(null)
      return
    }
    const enLista = usuarios.some(u => u._id === vIdUsuarioSolicitante)
    if (enLista) {
      setUsuarioExterno(null)
      return
    }
    let cancelled = false
    UsuarioCrud.obtenerxIdAsEdicion(vIdUsuarioSolicitante)
      .then(({ data }) => {
        if (!cancelled && data) setUsuarioExterno(data)
      })
      .catch(() => {
        if (!cancelled) setUsuarioExterno(null)
      })
    return () => {
      cancelled = true
    }
  }, [vIdUsuarioSolicitante, usuarios])

  return (
    <Form.Group>
      <Form.Label text='USUARIO SOLICITANTE' htmlFor='select-usuariosolicitante' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idUsuarioSolicitante'>
          {({ field }) => {
            const valorActual = field.value || ''
            const existeEnLista = usuarios.some(u => u._id === valorActual)
            const nombreExterno = usuarioExterno && usuarioExterno._id === valorActual
              ? `${(usuarioExterno.nombres || '').toUpperCase()} ${(usuarioExterno.apellidos || '').toUpperCase()}`.trim() ||
                usuarioExterno.username ||
                '(USUARIO DEL REQUERIMIENTO)'
              : '(USUARIO DEL REQUERIMIENTO)'
            return (
              <Form.Select
                {...field}
                disabled={fIsSubmitting || !vIdOficinaSolicitante}
                isInvalid={iTouched && iError}
                id='select-usuariosolicitante'
              >
                <option value=''>Seleccionar</option>
                {valorActual && !existeEnLista && (
                  <option value={valorActual}>{nombreExterno}</option>
                )}
                {usuarios.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombres?.toUpperCase()} {val.apellidos?.toUpperCase()}
                  </option>
                ))}
              </Form.Select>
            )
          }}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsuarioSolicitanteFormGroup)
